import { Button } from '@mui/material';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import React, { useEffect, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { Business_Profile_Enum } from '@kheops/graphql';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { contractAtom, currentContextAtom } from '../../../state';
import { useJoinOrCreateChat } from '../../../hooks/useJoinOrCreateChat';
import { RoutePaths } from '../../../routes/AppRoutes';

interface OrderContractChatButtonProps {
  buyingCompanyId: string;
  supplyingCompanyId: string;
}

export default function OrderContractChatButton({ buyingCompanyId, supplyingCompanyId }: OrderContractChatButtonProps): React.JSX.Element {
  const { realm } = useAtomValue(currentContextAtom);
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();
  
  const { joinOrCreateChat, loading, channelUrl } = useJoinOrCreateChat();

  const companyContractAtom = useMemo(() => {
    return contractAtom(buyingCompanyId, supplyingCompanyId);
  }, [buyingCompanyId, supplyingCompanyId]);
  
  const contract = useAtomValue(companyContractAtom);

  const onClick = (): void => {
    joinOrCreateChat(contract!);
  };

  useEffect(() => {
    if(channelUrl) {
      navigate(`${RoutePaths.CHAT_LIST}?channelUrl=${channelUrl}`);
    }
  }, [channelUrl])

  return (
    <Button
      loading={loading}
      startIcon={<MessageOutlinedIcon />}
      onClick={onClick}
      variant="outlined"
      color="error"
    >
      {realm === Business_Profile_Enum.Buyer ? t('common:contact_supplier') : t('common:contact_store')}
    </Button>
  );
}